import { ReactNode, CSSProperties, useMemo, forwardRef, FC, } from 'react';
import { InputNumber } from 'antd';
import classnames from 'classnames';
import { InputNumberProps as InputNumberCopyProps } from 'antd/lib/input-number';
import './style.less';

export type InputNumberProps = InputNumberCopyProps;
export interface NewInputNumberProps extends InputNumberProps {
  /** 单位 */
  company?: ReactNode;
  /** 单位宽度 */
  companyWidth?: number;
  /** 隐藏加减按钮 */
  hideAddon?: boolean;
}

const ProInputNumber: FC<NewInputNumberProps> = forwardRef<
  any,
  NewInputNumberProps
>((props, ref) => {
  const {
    className,
    company,
    companyWidth,
    style,
    hideAddon,
    ...restProps
  } = props;
  const classes = classnames(className, {
    'input-number-handler-hide': hideAddon,
  });
  const styles: CSSProperties = useMemo(() => {
    const currentStyle: CSSProperties = { ...style };
    if (company && companyWidth !== undefined) {
      currentStyle.width = `calc(100% - ${companyWidth}px)`;
      currentStyle.borderTopRightRadius = 0;
      currentStyle.borderBottomRightRadius = 0;
    }
    return currentStyle;
  }, [style, company, companyWidth]);
  const companyStyle: CSSProperties = useMemo(() => {
    if (companyWidth !== undefined) return { width: companyWidth };
    return {};
  }, [companyWidth]);
  return (
    <div className="yb-input-number-wrap" style={style}>
      <InputNumber
        ref={ref}
        className={classes}
        style={styles}
        {...restProps}
      />
      {!!company && (
        <div className="yb-input-number-company" style={companyStyle}>
          {company}
        </div>
      )}
    </div>
  );
});

ProInputNumber.defaultProps = {
  companyWidth: 28,
  hideAddon: true,
};

export default ProInputNumber;
